<template>
    <div>
        <a-button @click="showModal" class="btn-outline-primary" icon="eye">

        </a-button>

        <a-modal width="1000px" v-model="visible" title="  مشاهده درخواست" on-ok="handleOk">
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    بستن
                </a-button>

            </template>


            <template>
                <a-card title="اطلاعات درخواست ">

                    <a-card-grid style="width: 50%; text-align: center">
                    {{ info.order.user ? $root.full_name(info.order.user.firstname,info.order.user.lastname) : '' }}
                    </a-card-grid>

                    <a-card-grid style="width: 50%; text-align: center">خریدار</a-card-grid>
                       <a-card-grid style="width: 50%; text-align: center">
                     {{ info.order_item.product.presenter ? $root.full_name(info.order_item.product.presenter.firstname,info.order_item.product.presenter.lastname) : '' }}
                    </a-card-grid>

                    <a-card-grid style="width: 50%; text-align: center">فروشنده</a-card-grid>
                     <a-card-grid style="width: 50%; text-align: center">

                        <b-badge pill v-if="info.status == 'pending'" variant="info" class="bg-warning">
                                                درانتظار</b-badge>
                                                 <b-badge pill variant="info" pill v-else-if="info.status == 'accepted'"  class="bg-success">
                                                قبول شده</b-badge>
                                                 <b-badge pill variant="danger" v-else class="bg-danger">
                                                رد شده</b-badge>

                    </a-card-grid>
                    <a-card-grid style="width: 50%; text-align: center">وضعیت</a-card-grid>
                       <a-card-grid style="width: 50%; text-align: center">{{$root.number_format(info.order_item.total_cash) }}
                    </a-card-grid>

                    <a-card-grid style="width: 50%; text-align: center">قیمت نقدی</a-card-grid>
                       <a-card-grid style="width: 50%; text-align: center">{{$root.number_format(info.order_item.total_barter)  }}
                    </a-card-grid>

                    <a-card-grid style="width: 50%; text-align: center">قیمت تهاتری</a-card-grid>
                       <a-card-grid style="width: 50%; text-align: center">{{info.operator ?  $root.full_name(info . operator . firstname , info . operator . lastname) : '-' }}
                    </a-card-grid>

                    <a-card-grid style="width: 50%; text-align: center">اپراتور</a-card-grid>
                       <a-card-grid style="width: 50%; text-align: center">{{ info.order_item.product ? info.order_item.product.title : '' }}
                    </a-card-grid>

                    <a-card-grid style="width: 50%; text-align: center">نام محصول</a-card-grid>
                    


                   

                </a-card>
            </template>




            <form @submit.prevent="addData($event)" v-show="$root.hasPermission('/orders/return/')" >
                <input type="hidden" name="order_item_id" :value="info.order_item_id"   />
                <div class="row text-right mt-md-5">
                    <h6> تغییر وضعیت درخواست</h6>
                    <hr />
                    <div class="col-md-8 my-1"></div>
                    <div class="col-md-4 my-1">
                        <label class="sr-only" for="inline-form-input-name"> وضعیت درخواست</label>
                        <select v-model="info.status" class="form-control" name="status">
                            <option value="">انتخاب</option>
                            <option value="accepted">قبول شده</option>
                            <option value="denied">رد شده </option>
                        </select>
                    </div>

                    <div class="col-md-1 my-1">
                        <button :disabled="loading" type="submit" class="btn btn-fill btn-outline-success ">
                            ذخیره
                        </button>
                    </div>
                </div>
            </form>
        </a-modal>
    </div>
</template>
<script>
    export default {
        props: {
            info: Object,
        },
        data() {
            return {
                loading: false,
                visible: false,
            };
        },
        methods: {
            addData(event) {
                let _this = this;
                let data = new FormData(event.target);
                this.loading = true;
                let url = `/orders/return/status`
                axios
                    .post(url, data)
                    .then(function(response) {
                        console.log(response)
                        _this.loading = false;
                        _this.$toast.success("  درخواست با موفقیت ویرایش شد");
                    })
                    .catch(function(err) {
                        _this.loading = false;
                        _this.$root.handleAxiosError(err);
                    });
            },
            showModal() {
                this.visible = true;
            },
            handleOk(e) {
                this.loading = true;
                setTimeout(() => {
                    this.visible = false;
                    this.loading = false;
                }, 3000);
            },
            handleCancel(e) {
                this.visible = false;
                this.$emit('getData')
            },
        }
    };
</script>
